import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Route from '../common/Route';
import EmailRoutes from '../Email';
import PasswordRoutes from '../Password';
import EnterForm from '../../components/Enter/EnterForm';
import RestoreRoute from './Restore';
import ReferralSignUp from './ReferralSignUp';
import AccountCode from './AccountCode';

const EnterRoutes = () => {
  const { path } = useRouteMatch();

  const intl = useIntl();

  return (
    <Switch>
      <Route
        exact
        path={path}
        title={intl.formatMessage({
          id: 'enter.seo.title',
          defaultMessage: 'ClearVPN | Enter',
          description: 'SEO title of the Enter page, that provides user with available login options',
        })}
      >
        <EnterForm />
      </Route>

      <Route
        exact
        path={`${path}/restore`}
        title={intl.formatMessage({
          id: 'accountRestore.seo.title',
          defaultMessage: 'ClearVPN | Restore account',
          description:
            'SEO title of the account restore page, where user ends if they tried to login into a deleted account',
        })}
      >
        <RestoreRoute />
      </Route>

      <Route
        exact
        path={`${path}/referral`}
        title={intl.formatMessage({
          id: 'refSignUp.seo.title',
          defaultMessage: 'ClearVPN | Redeem code',
          description: 'SEO title of the referral sign up page',
        })}
      >
        <ReferralSignUp />
      </Route>

      <Route
        exact
        path={`${path}/account-code`}
        title={intl.formatMessage({
          id: 'accountCode.seo.title',
          defaultMessage: 'ClearVPN | Account Code',
          description: 'SEO title of the account code sign up page',
        })}
      >
        <AccountCode />
      </Route>

      <Route path={`${path}/email`}>
        <EmailRoutes />
      </Route>

      <Route path={`${path}/password`}>
        <PasswordRoutes />
      </Route>

      <Route exact path={`${path}/login`}>
        <Redirect to={{ pathname: path, search: window.location.search }} />
      </Route>
    </Switch>
  );
};

export default EnterRoutes;
